import { render, staticRenderFns } from "./AdminAdd.vue?vue&type=template&id=16e17f2e&scoped=true&"
import script from "./AdminAdd.vue?vue&type=script&lang=js&"
export * from "./AdminAdd.vue?vue&type=script&lang=js&"
import style0 from "./AdminAdd.vue?vue&type=style&index=0&id=16e17f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e17f2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
